import { render, staticRenderFns } from "./singleCompletion.vue?vue&type=template&id=854fda1e&scoped=true&"
import script from "./singleCompletion.vue?vue&type=script&lang=ts&"
export * from "./singleCompletion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854fda1e",
  null
  
)

export default component.exports